var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import RecommendationSvg from "assets/svg/recommandations.svg";
import React from "react";
import { useTranslation } from "react-i18next";
import { Text } from "rebass";
import CollectionList from "src/components/blocks/CollectionList";
import { LinkButton } from "src/components/elements/Button";
import Title from "src/components/typography/Title";
import { Content } from "src/components/utilities/Containers";
import { svgStyle } from "src/styles/helpers";
import { breakpoints } from "src/styles/theme";
import styled from "styled-components";
var RecommendationIcon = styled(RecommendationSvg)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  height: 2rem;\n\n  @media (min-width: ", ") {\n    min-height: 2.6rem;\n  }\n"], ["\n  ", ";\n  height: 2rem;\n\n  @media (min-width: ", ") {\n    min-height: 2.6rem;\n  }\n"])), svgStyle, breakpoints.md);
var RecommendedCollections = function (_a) {
    var collections = _a.collections;
    var t = useTranslation().t;
    return (React.createElement(Content, { mt: 3 },
        React.createElement(Title, { sm: true, icon: React.createElement(RecommendationIcon, null) }, t("recommendedSeries")),
        React.createElement(CollectionList, { data: collections }),
        collections.length >= 3 && (React.createElement(Text, { pt: 1, textAlign: "center" },
            React.createElement(LinkButton, { to: "/mes-recommandations", css: "width: 100%; max-width: 22rem;" }, t("seeMoreSeries"))))));
};
export default RecommendedCollections;
var templateObject_1;
